import React, { useEffect } from 'react';
import './QuestAuditContainer.scss';
import QuestAuditIndex from './QuestAuditIndex';

export default function QuestAuditContainer(props) {
  // 在组件挂载后移除 min-height
  useEffect(() => {
    // 找到 Main_Container 元素
    const mainContainer = document.querySelector('.Main_Container');
    if (mainContainer) {
      // 移除 min-height 属性
      mainContainer.style.minHeight = 'unset';
    }
    
    // 组件卸载时恢复原始样式
    return () => {
      const mainContainer = document.querySelector('.Main_Container');
      if (mainContainer) {
        // 移除我们设置的 style，让其恢复原样
        mainContainer.style.removeProperty('min-height');
      }
    };
  }, []);

  return (
    <div className="admin-quest-audit-container">
      <div className="content-wrapper">
        <h1 className="page-title">任务审计</h1>
        <QuestAuditIndex {...props} />
      </div>
    </div>
  );
}